var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadArrowLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6572_6213",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6572_6213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99924 1.59241C7.81005 1.59267 7.62869 1.66801 7.49501 1.80189C7.36132 1.93576 7.28624 2.11722 7.28624 2.30641V9.14441L5.65424 7.51241C5.5203 7.37847 5.33865 7.30323 5.14924 7.30323C4.95982 7.30323 4.77817 7.37847 4.64424 7.51241C4.5103 7.64634 4.43506 7.82799 4.43506 8.01741C4.43506 8.20682 4.5103 8.38847 4.64424 8.52241L7.46124 11.3394C7.52529 11.4129 7.60373 11.4725 7.69172 11.5146C7.7797 11.5566 7.87536 11.5802 7.9728 11.5839C8.07024 11.5875 8.1674 11.5712 8.25829 11.5358C8.34917 11.5005 8.43185 11.4469 8.50124 11.3784C8.51603 11.3663 8.53006 11.3533 8.54324 11.3394L11.3602 8.52241C11.4893 8.38762 11.5605 8.20765 11.5585 8.02103C11.5565 7.83442 11.4816 7.656 11.3497 7.52398C11.2178 7.39195 11.0394 7.31681 10.8528 7.31465C10.6662 7.31248 10.4862 7.38347 10.3512 7.51241L8.71324 9.15041V2.30641C8.71324 2.11704 8.63801 1.93543 8.50411 1.80153C8.37021 1.66763 8.1886 1.59241 7.99924 1.59241Z",
    fill: "#594AA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.57714 13.0114C1.4812 13.0078 1.38551 13.0236 1.29581 13.0578C1.20611 13.092 1.12424 13.144 1.05509 13.2106C0.985937 13.2772 0.930932 13.3571 0.893361 13.4455C0.85579 13.5338 0.836426 13.6289 0.836426 13.7249C0.836426 13.8209 0.85579 13.9159 0.893361 14.0043C0.930932 14.0926 0.985937 14.1725 1.05509 14.2391C1.12424 14.3057 1.20611 14.3577 1.29581 14.3919C1.38551 14.4262 1.4812 14.442 1.57714 14.4384H14.4231C14.5191 14.442 14.6148 14.4262 14.7045 14.3919C14.7942 14.3577 14.876 14.3057 14.9452 14.2391C15.0143 14.1725 15.0694 14.0926 15.1069 14.0043C15.1445 13.9159 15.1639 13.8209 15.1639 13.7249C15.1639 13.6289 15.1445 13.5338 15.1069 13.4455C15.0694 13.3571 15.0143 13.2772 14.9452 13.2106C14.876 13.144 14.7942 13.092 14.7045 13.0578C14.6148 13.0236 14.5191 13.0078 14.4231 13.0114H1.57714Z",
    fill: "#594AA5"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6572_6213)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.515625,
    width: 15,
    height: 15,
    fill: "#594AA5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6572_6213"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(0.5 0.515625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadArrowLine);
export default __webpack_public_path__ + "static/media/download-arrow-line.cbfef9e2ae22a29cb68600988d56235e.svg";
export { ForwardRef as ReactComponent };